// extracted by mini-css-extract-plugin
module.exports = {"root":"inviteeResponse_root__XCN2a","container":"inviteeResponse_container__CaVqp","backLink":"inviteeResponse_backLink__ch3Qr"};